// GENERATED from server/src/email-templates/business-weekly/business-weekly.hbs (Oct 2026 rebrand).
// Keep in sync with the server template: re-run the generator rather than editing by hand.
// Differences vs server: cid: inline images are {{logoImg}} / {{mastheadImg}}; <html>/<head>/<body> wrapper
// is replaced by a <div> carrying the body style so it can be injected into the admin preview pane.
/* eslint-disable */
export const htmlTemplate = `<style type="text/css">
	#outlook a { padding: 0; }
	.ReadMsgBody, .ExternalClass { width: 100%; }
	.ExternalClass * { line-height: 100%; }
	body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; background-color: #efe7d6; }
	table, td { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
	img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }
	p { display: block; margin: 0 0 14px 0; }
	.bhi-body p { margin: 0 0 14px 0; }
	.bhi-body a { color: #8a6a3c; }
	a { color: #8a6a3c; }
	</style><style type="text/css">
	@media only screen and (max-width: 620px) {
		.bhi-wrap { width: 100% !important; }
		.bhi-pad { padding-left: 18px !important; padding-right: 18px !important; }
		.bhi-stack { display: block !important; width: 100% !important; text-align: center !important; }
		.bhi-stack-img { margin: 0 auto !important; }
		.bhi-masthead { width: 260px !important; }
		.bhi-logo { width: 110px !important; }
		.bhi-title { font-size: 24px !important; line-height: 30px !important; }
		.bhi-quote { font-size: 17px !important; line-height: 26px !important; }
		.bhi-tagline { text-align: center !important; }
		.bhi-meta-cell { display: block !important; width: 100% !important; text-align: center !important; padding: 2px 0 !important; }
	}
	</style>
<div style="margin:0;padding:0;background-color:#efe7d6;">
	<div style="display:none;font-size:1px;color:#efe7d6;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">{{headline}}</div>

	<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#efe7d6;">
		<tr>
			<td align="center" style="padding:24px 12px;">

				<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0" width="600" align="center"><tr><td><![endif]-->
				<table role="presentation" class="bhi-wrap" border="0" cellpadding="0" cellspacing="0" width="600" style="width:600px;max-width:600px;background-color:#faf7f0;border:1px solid #dbc6a7;" dir="{{direction}}">

					<!-- ===== MASTHEAD ===== -->
					<tr>
						<td class="bhi-pad" style="padding:14px 28px 0 28px;">
							<div style="font-family:'Times New Roman',Times,serif;font-size:11px;line-height:14px;color:#553f2f;text-align:right;">בס"ד</div>
						</td>
					</tr>
					<tr>
						<td class="bhi-pad" style="padding:6px 28px 0 28px;">
							<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" dir="{{direction}}">
								<tr>
									<td class="bhi-stack" width="190" valign="middle" style="width:190px;padding:10px 0 14px 0;" align="{{align}}">
										<a href="{{bwLink}}" style="text-decoration:none;" target="_blank">
											<img class="bhi-logo bhi-stack-img" src="{{logoImg}}" width="130" alt="Business Halacha Institute &middot; מכון לחושן משפט" style="display:block;width:130px;height:auto;border:0;">
										</a>
									</td>
									<td class="bhi-stack" valign="middle" align="center" style="padding:10px 0 14px 0;">
										{{#if isHE}}
										<div class="bhi-tagline" style="font-family:'Frank Ruhl Libre','Times New Roman',Times,serif;font-size:13px;line-height:18px;color:#553f2f;text-align:center;padding-bottom:6px;">יו"ל ע"י בית הוראה עץ חיים &middot; בנשיאות הרב חיים קאהן שליט"א</div>
										<img class="bhi-masthead" src="{{mastheadImg}}" width="300" alt="משא ומתן" style="display:block;width:300px;height:auto;border:0;margin:0 auto;">
										{{else}}
										<div class="bhi-tagline" style="font-family:'Playfair Display',Georgia,'Times New Roman',serif;font-size:13px;line-height:18px;letter-spacing:0.5px;color:#553f2f;text-align:center;padding-bottom:6px;">Restoring The Primacy Of <span style="font-weight:600;">Choshen Mishpat</span></div>
										<img class="bhi-masthead" src="{{mastheadImg}}" width="330" alt="Business Weekly" style="display:block;width:330px;height:auto;border:0;margin:0 auto;">
										<div class="bhi-tagline" style="font-family:'Playfair Display',Georgia,'Times New Roman',serif;font-size:13px;line-height:18px;color:#553f2f;text-align:center;padding-top:6px;">Under the auspices of <span style="font-weight:600;">Harav Chaim Kohn, Shlita</span></div>
										{{/if}}
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- ===== ISSUE STRIP ===== -->
					<tr>
						<td class="bhi-pad" style="padding:0 28px;">
							<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#f2e8d5;">
								<tr>
									<td style="padding:10px 16px;border-top:1px solid #c29c67;border-bottom:1px solid #c29c67;">
										<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" dir="{{direction}}">
											<tr>
												<td class="bhi-meta-cell" align="{{align}}" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:18px;color:#3d2e1f;">
													{{#if issue}}<span style="color:#8a6a3c;">{{issueLabel}}</span> <span style="font-weight:bold;">{{issue}}</span>{{/if}}
												</td>
												<td class="bhi-meta-cell" align="center" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:18px;color:#c29c67;">&#9670;</td>
												<td class="bhi-meta-cell" align="{{#if isHE}}left{{else}}right{{/if}}" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:18px;color:#3d2e1f;">
													<span style="font-weight:bold;">{{name}}</span>{{#if hDate}} &middot; {{hDate}}{{/if}}{{#if date}} <span style="color:#6b6e70;">&middot; {{date}}</span>{{/if}}
												</td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- ===== HEADLINE (pull quote) ===== -->
					{{#if headline}}
					<tr>
						<td class="bhi-pad" style="padding:28px 28px 0 28px;">
							<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" dir="{{direction}}">
								<tr>
									<td style="padding:4px 18px;border-{{align}}:3px solid #c29c67;">
										<div class="bhi-quote" style="font-family:{{#if isHE}}'Frank Ruhl Libre','Times New Roman',Times,serif{{else}}'Playfair Display',Georgia,'Times New Roman',serif{{/if}};font-size:19px;font-weight:500;line-height:29px;color:#553f2f;text-align:{{align}};direction:{{direction}};">
											{{#if isHE}}"{{headline}}"{{else}}&ldquo;{{headline}}&rdquo;{{/if}}
										</div>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					{{/if}}

					<!-- ===== ARTICLE ===== -->
					<tr>
						<td class="bhi-pad" style="padding:26px 28px 0 28px;direction:{{direction}};">
							{{#if title}}
							<div class="bhi-title" style="font-family:{{#if isHE}}'Frank Ruhl Libre','Times New Roman',Times,serif{{else}}'Playfair Display',Georgia,'Times New Roman',serif{{/if}};font-size:28px;font-weight:700;line-height:34px;color:#3d2e1f;text-align:{{align}};direction:{{direction}};">{{title}}</div>
							{{/if}}
							{{#if author}}
							<div style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:12px;font-weight:bold;letter-spacing:1px;line-height:18px;color:#8a6a3c;text-transform:uppercase;text-align:{{align}};direction:{{direction}};padding-top:6px;">{{author}}</div>
							{{/if}}
							<table role="presentation" border="0" cellpadding="0" cellspacing="0" dir="{{direction}}" style="margin-top:14px;">
								<tr>
									<td style="width:64px;height:2px;background-color:#c29c67;font-size:0;line-height:0;">&nbsp;</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<td class="bhi-pad bhi-body" style="padding:18px 28px 6px 28px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;line-height:26px;color:#2b2622;text-align:{{align}};direction:{{direction}};">
							{{{text}}}
						</td>
					</tr>
					<tr>
						<td align="center" style="padding:10px 28px 30px 28px;">
							<table role="presentation" border="0" cellpadding="0" cellspacing="0">
								<tr>
									<td align="center" bgcolor="#553f2f" style="background-color:#553f2f;border:1px solid #3d2e1f;">
										<a href="{{bwLink}}" target="_blank" style="display:inline-block;padding:12px 30px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:15px;font-weight:bold;letter-spacing:0.5px;line-height:18px;color:#faf7f0;text-decoration:none;">{{btnLabel}}</a>
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- ===== SPONSOR ===== -->
					<tr>
						<td class="bhi-pad" style="padding:0 28px;">
							<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#f2e8d5;" dir="{{direction}}">
								<tr>
									<td style="padding:18px 20px;border-top:1px solid #dbc6a7;border-bottom:1px solid #dbc6a7;">
										<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" dir="{{direction}}">
											<tr>
												<td class="bhi-stack" valign="middle" align="{{align}}" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;line-height:20px;color:#3d2e1f;direction:{{direction}};padding-bottom:6px;">
													{{#if isHE}}
													<span style="font-weight:bold;">תמכו במכון לחושן משפט</span><br>הקדישו גליון של משא ומתן לע"נ, לרפואה או לכבוד שמחה.
													{{else}}
													<span style="font-weight:bold;">Help support BHI</span><br>Dedicate a week of Business Weekly in memory of a loved one or in honor of a simcha.
													{{/if}}
												</td>
												<td class="bhi-stack" valign="middle" align="{{#if isHE}}left{{else}}right{{/if}}" style="padding-top:6px;">
													<table role="presentation" border="0" cellpadding="0" cellspacing="0" align="{{#if isHE}}left{{else}}right{{/if}}" style="{{#if isHE}}margin-right:auto;{{else}}margin-left:auto;{{/if}}">
														<tr>
															<td align="center" bgcolor="#c29c67" style="background-color:#c29c67;">
																<a href="{{sponsorLink}}" target="_blank" rel="noopener noreferrer" style="display:inline-block;padding:10px 20px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;font-weight:bold;line-height:16px;color:#3d2e1f;text-decoration:none;white-space:nowrap;">{{#if isHE}}לתרומה והקדשה{{else}}Sponsor an issue{{/if}}</a>
															</td>
														</tr>
													</table>
												</td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- ===== OPTIONAL FOOTER NOTE ===== -->
					{{#unless footer}}
					{{#if footerText}}
					<tr>
						<td class="bhi-pad" style="padding:22px 28px 0 28px;direction:{{direction}};">
							{{#if footerTitle}}
							<div style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:15px;font-weight:bold;line-height:22px;color:#3d2e1f;text-align:{{align}};">{{footerTitle}}</div>
							{{/if}}
							<div style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;line-height:22px;color:#4a4540;text-align:{{align}};">{{{footerText}}}</div>
						</td>
					</tr>
					{{/if}}
					{{/unless}}

					<!-- ===== INSTITUTE FOOTER ===== -->
					<tr>
						<td class="bhi-pad" align="center" style="padding:30px 28px 26px 28px;">
							<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
								<tr>
									<td align="center" style="padding-bottom:14px;">
										<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
											<tr>
												<td style="height:1px;background-color:#c29c67;font-size:0;line-height:0;">&nbsp;</td>
												<td width="30" align="center" style="width:30px;font-family:Arial,sans-serif;font-size:12px;line-height:12px;color:#c29c67;">&#9670;</td>
												<td style="height:1px;background-color:#c29c67;font-size:0;line-height:0;">&nbsp;</td>
											</tr>
										</table>
									</td>
								</tr>
								<tr>
									<td align="center" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:20px;color:#3d2e1f;padding-bottom:10px;direction:rtl;">
										לדיני תורה, שאלות בדיני ממונות, שטרות, ריבית, צוואות, דיני מקח וממכר בשבת ויו"ט, או לכל ענין הקשור לגליון אפשר להתקשר:
									</td>
								</tr>
								<tr>
									<td align="center" style="padding-bottom:4px;">
										<img src="{{logoImg}}" width="110" alt="מכון לחושן משפט &middot; Business Halacha Institute" style="display:block;width:110px;height:auto;border:0;margin:0 auto;">
									</td>
								</tr>
								<tr>
									<td align="center" dir="ltr" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;font-weight:bold;line-height:22px;color:#3d2e1f;padding-top:8px;direction:ltr;">
										718.233.3845 &nbsp;&middot;&nbsp; <a href="mailto:ask@businesshalacha.com" style="color:#3d2e1f;text-decoration:none;">ask@businesshalacha.com</a>
									</td>
								</tr>
								<tr>
									<td align="center" dir="ltr" style="font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:13px;line-height:20px;color:#3d2e1f;direction:ltr;">
										<a href="https://www.businesshalacha.com" style="color:#3d2e1f;text-decoration:none;">www.businesshalacha.com</a><br>
										1937 Ocean Ave. Brooklyn, NY 11230
									</td>
								</tr>
								<tr>
									<td align="center" style="padding-top:18px;">
										<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#f2e8d5;">
											<tr>
												<td align="center" style="padding:12px 16px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:12px;line-height:18px;color:#553f2f;">
													{{#if isHE}}
													לקבלת הגליון באימייל, שלחו אימייל: <a href="mailto:mm@businesshalacha.com" style="color:#553f2f;">mm@businesshalacha.com</a>
													{{else}}
													Know someone who would enjoy Business Weekly? Forward this email, or have them write to <a href="mailto:mm@businesshalacha.com" style="color:#553f2f;">mm@businesshalacha.com</a>
													{{/if}}
												</td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
				<!--[if mso | IE]></td></tr></table><![endif]-->

				<!-- ===== LEGAL ===== -->
				<table role="presentation" class="bhi-wrap" border="0" cellpadding="0" cellspacing="0" width="600" style="width:600px;max-width:600px;">
					<tr>
						<td align="center" dir="ltr" style="padding:18px 20px 6px 20px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:11px;line-height:16px;color:#6b6e70;direction:ltr;">
							&copy; Business Halacha Institute. Choshen Mishpat is applicable to every aspect of contemporary transactions. BHI is committed to providing you with the awareness and knowledge you need to navigate today&rsquo;s business world according to halacha.
						</td>
					</tr>
					<tr>
						<td align="center" style="padding:4px 20px 10px 20px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:11px;line-height:16px;color:#6b6e70;">
							<a href="%mailing_list_unsubscribe_url%" target="_blank" rel="noopener noreferrer" style="color:#6b6e70;">{{#if isHE}}להסרה מרשימת התפוצה{{else}}Unsubscribe{{/if}}</a>
						</td>
					</tr>
				</table>

			</td>
		</tr>
	</table>
</div>`;
